import React from "react";
import { type CWEnv, initCWElements } from "@cw-elements/config";
import { initMfes } from "@cw-elements/mfe-setup/init";
import { withLDProvider } from "launchdarkly-react-client-sdk";
import ReactDOM from "react-dom/client";
import "syngenta-digital-cropwise-react-ui-kit/dist/styles/cw-ui-kit.less";
import App from "./App";
import AppProviders from "./context";
import "./i18n";
import "./index.less";
import reportWebVitals from "./reportWebVitals";
import ConfigMissing from "./shared/config-missing";
import { getAccessToken } from "./shared/utils/axios";

const isConfigurationGood = Boolean(
  process.env.REACT_APP_ENV &&
    process.env.REACT_APP_ACCOUNTS_ENDPOINT &&
    process.env.REACT_APP_BASE_API_URL &&
    process.env.REACT_APP_API_URL &&
    process.env.REACT_APP_OAUTH_CLIENT_ID
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

async function bootstrap(): Promise<void> {
  const mfeUrl = process.env.REACT_APP_CW_ELEMENTS_MFES ?? "";
  if (mfeUrl) {
    let token;
    try {
      token = getAccessToken() ?? undefined;
      const cwElementsConfig = {
        environment: process.env.REACT_APP_CW_ELEMENTS_ENVIRONMENT as CWEnv,
        token,
        hostAppId: process.env.REACT_APP_ID,
      };
      initCWElements(cwElementsConfig);
      await initMfes({
        "entities-hall": `${mfeUrl}/entities-hall`,
        "topbar-navigation": `${mfeUrl}/topbar-navigation`,
        "ai-chatbot": `${mfeUrl}/ai-chatbot`,
      });
      initApp();
    } catch (error) {
      console.error(error);
    }
  }
}

void (async function () {
  try {
    await bootstrap();
  } catch (e) {
    console.error(e);
  }
})();

const LDProvider = withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID as string,
})(App);

function initApp(): void {
  root.render(
    <>
      {isConfigurationGood ? (
        <AppProviders>
          <LDProvider />
        </AppProviders>
      ) : (
        <ConfigMissing />
      )}
    </>
  );
}

reportWebVitals();
